export enum ProviderDashboardEvents {
  viewed = 'Provider Dashboard Viewed',
  refreshed = 'Provider Dashboard Refreshed',
  myDayViewCalendarClicked = 'Provider Dashboard My Day View Calendar Clicked',
  myDayChartSegmentHovered = 'Provider Dashboard My Day Chart Segment Hovered',
  myDayLegendHovered = 'Provider Dashboard My Day Legend Hovered',
  myPatientsTabSwitched = 'Provider Dashboard My Patients Tab Switched',
  myPatientsPatientClicked = 'Provider Dashboard My Patients Patient Clicked',
  myPatientsPageChanged = 'Provider Dashboard My Patients Page Changed',
  myPatientsItemsPerPageChanged = 'Provider Dashboard My Patients Items Per Page Changed',
  myPatientsPastSessionsToggled = 'Provider Dashboard My Patients Past Sessions Toggled',
  myPatientsAppointmentClicked = 'Provider Dashboard My Patients Appointment Clicked',
  myPatientsJoinSessionClicked = 'Provider Dashboard My Patients Join Session Clicked',
  pendingNotesNoteClicked = 'Provider Dashboard Pending Notes Note Clicked',
  pendingNotesShowMoreClicked = 'Provider Dashboard Pending Notes Show More Clicked',
  pendingNotesShowLessClicked = 'Provider Dashboard Pending Notes Show Less Clicked',
  myPatientsDischargeRowClicked = 'Provider Dashboard My Patients Discharge Row Clicked',
  myPatientsOpenDischargePlanClicked = 'Provider Dashboard My Patients Open Discharge Plan Clicked',
}
